import React from 'react';
import './header.css'

const Header = () => {
  return <div className='jumbotron text-center'>
       <h1>Tech Stack</h1>
         </div>
}
export default Header;
